const FOREIGN_KEY_VIOLATION = "23503";
const UNIQUE_VIOLATION = "23505";

function extractPgError(
  err: unknown
): { code?: unknown; constraint_name?: unknown } | null {
  const candidate =
    err instanceof Error && "cause" in err && err.cause instanceof Error
      ? err.cause
      : err;
  if (!(candidate instanceof Error) || !("code" in candidate)) return null;
  return candidate as { code?: unknown; constraint_name?: unknown };
}

function matches(
  err: unknown,
  sqlState: string,
  constraintName?: string
): boolean {
  const pg = extractPgError(err);
  if (!pg || pg.code !== sqlState) return false;
  if (constraintName === undefined) return true;
  return pg.constraint_name === constraintName;
}

export function isForeignKeyViolation(
  err: unknown,
  constraintName?: string
): boolean {
  return matches(err, FOREIGN_KEY_VIOLATION, constraintName);
}

export function isUniqueConstraintViolation(
  err: unknown,
  constraintName?: string
): boolean {
  return matches(err, UNIQUE_VIOLATION, constraintName);
}
